export default __webpack_public_path__ + "static/stainless_steel_prices-7f8926276ebc4782f1a03be3359b4e11.png";